import { useMemo } from "react"

import { AuthHelper } from "../helpers/auth.helper"
import { useAppSelector } from "../store/selectors/app.selector"
import { userDetailsSelector } from "../store/selectors/userDetails.selector"

export const useDemoMode = () => {
    const userDetailsState = useAppSelector(userDetailsSelector)

    const isDemo = useMemo(() => {
        return (
            !!userDetailsState.profile?.isDemo ||
            AuthHelper.isDemoSessionActive()
        )
    }, [userDetailsState.profile?.isDemo])

    return { isDemo }
}
